<header
  class="h-16 bg-card border-b border-border flex items-center justify-between pl-6 pr-3 shrink-0 z-30"
>
  <div class="flex items-center gap-4 flex-1 min-w-0">
    <button
      type="button"
      class="shell-header-ghost-btn lg:hidden p-2 -ml-2 text-muted-foreground rounded-md hover:bg-muted"
      (click)="menuClick.emit()"
      aria-label="Mở menu"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-5 h-5"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <div class="relative w-full max-w-md flex-1 min-w-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground w-[18px] h-[18px] pointer-events-none"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <input
        type="text"
        class="w-full pl-10 pr-4 py-2 bg-background border border-border text-foreground placeholder:text-muted-foreground focus:border-primary transition-all outline-none text-sm rounded-[var(--radius-card1)]"
        placeholder="Tìm kiếm nhân viên, hợp đồng... (⌘K)"
        pInputText
        autocomplete="off"
      />
    </div>
  </div>

  <div class="flex items-center gap-3 shrink-0">
    <button
      type="button"
      class="shell-header-ghost-btn p-2 text-muted-foreground hover:bg-muted rounded-full transition-colors hidden sm:block"
      (click)="toggleTheme()"
      [attr.title]="
        isDarkMode ? 'Chuyển sang chế độ sáng' : 'Chuyển sang chế độ tối'
      "
    >
      <svg
        *ngIf="isDarkMode"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-[18px] h-[18px]"
        aria-hidden="true"
      >
        <path
          d="M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.894a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM18.894 17.106a.75.75 0 0 0 1.06-1.06l-1.591-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.757 17.657a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.591-1.59a.75.75 0 0 0-1.06 1.06l1.59 1.591Z"
        />
      </svg>
      <svg
        *ngIf="!isDarkMode"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-[18px] h-[18px]"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <button
      type="button"
      class="shell-header-ghost-btn p-2 text-muted-foreground hover:bg-muted rounded-full transition-colors hidden sm:block"
      aria-label="Thông báo"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-[18px] h-[18px]"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <button
      type="button"
      class="shell-header-ghost-btn p-2 text-muted-foreground hover:bg-muted rounded-full transition-colors hidden sm:block"
      aria-label="Trợ giúp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-[18px] h-[18px]"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.21 1.06 1.21 2.98 0 4.04-.314.274-.5.68-.5 1.1v.75a.75.75 0 0 1-1.5 0v-.75c0-1.154.734-2.184 1.75-2.756a.75.75 0 0 0 0-1.25ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <div class="relative">
      <button
        type="button"
        class="shell-header-ghost-btn p-2 rounded-full transition-colors hidden sm:block"
        [ngClass]="{
          'bg-muted text-primary': isLanguageDropdownOpen,
          'text-muted-foreground hover:bg-muted': !isLanguageDropdownOpen
        }"
        title="Chuyển đổi ngôn ngữ"
        (click)="
          isLanguageDropdownOpen = !isLanguageDropdownOpen;
          isModuleDropdownOpen = false;
          isUserMenuOpen = false
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="w-[18px] h-[18px]"
          aria-hidden="true"
        >
          <path
            d="M15.75 8.25a.75.75 0 0 1 .75.75c0 1.12-.492 2.126-1.27 2.84a.75.75 0 1 1-.96-1.18.98.98 0 0 0 .73-.66H15a.75.75 0 0 1 .75-.75Z"
          />
          <path
            fill-rule="evenodd"
            d="M12 2.25A9.75 9.75 0 0 0 2.25 12c0 5.384 4.365 9.75 9.75 9.75 2.209 0 4.25-.804 5.814-2.13a.75.75 0 0 0-1.001-1.12 8.25 8.25 0 1 1 0-12.5.75.75 0 0 0 1-1.12A9.75 9.75 0 0 0 12 2.25ZM8.25 9.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H9Z"
            clip-rule="evenodd"
          />
          <path
            d="M14.955 5.435a.75.75 0 0 1 .09.894 8.252 8.252 0 0 1-1.635 8.867.75.75 0 1 1-1.06-1.06 6.75 6.75 0 0 0 1.338-7.248.75.75 0 0 1 .267-.451Z"
          />
        </svg>
      </button>

      <ng-container *ngIf="isLanguageDropdownOpen">
        <div
          class="fixed inset-0 z-[90]"
          (click)="isLanguageDropdownOpen = false"
        ></div>
        <div
          class="absolute right-0 top-full mt-2 bg-card border border-border z-[100] min-w-[180px] rounded-[var(--radius-card2)] shadow-elevation-md"
        >
          <div class="py-2 text-sm">
            <button
              type="button"
              class="shell-header-menu-btn w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors border-0 cursor-pointer text-left hover:bg-muted"
              [ngClass]="{
                'bg-primary/10 text-primary': translate.currentLang === 'vi',
                'text-foreground': translate.currentLang !== 'vi'
              }"
              (click)="saveLang('vi')"
            >
              <span class="flex items-center gap-2">
                <span
                  class="fi fi-vn w-5 h-[15px] shrink-0 rounded-sm"
                  aria-hidden="true"
                ></span>
                <span>Tiếng Việt</span>
              </span>
              <span
                *ngIf="translate.currentLang === 'vi'"
                class="w-1.5 h-1.5 rounded-full bg-primary shrink-0"
              ></span>
            </button>
            <button
              type="button"
              class="shell-header-menu-btn w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors border-0 cursor-pointer text-left hover:bg-muted"
              [ngClass]="{
                'bg-primary/10 text-primary': translate.currentLang === 'en',
                'text-foreground': translate.currentLang !== 'en'
              }"
              (click)="saveLang('en')"
            >
              <span class="flex items-center gap-2">
                <span
                  class="fi fi-gb w-5 h-[15px] shrink-0 rounded-sm"
                  aria-hidden="true"
                ></span>
                <span>English</span>
              </span>
              <span
                *ngIf="translate.currentLang === 'en'"
                class="w-1.5 h-1.5 rounded-full bg-primary shrink-0"
              ></span>
            </button>
            <button
              type="button"
              class="shell-header-menu-btn w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors border-0 cursor-pointer text-left hover:bg-muted"
              [ngClass]="{
                'bg-primary/10 text-primary': translate.currentLang === 'cn',
                'text-foreground': translate.currentLang !== 'cn'
              }"
              (click)="saveLang('cn')"
            >
              <span class="flex items-center gap-2">
                <span
                  class="fi fi-cn w-5 h-[15px] shrink-0 rounded-sm"
                  aria-hidden="true"
                ></span>
                <span>中文 (Zhōngwén)</span>
              </span>
              <span
                *ngIf="translate.currentLang === 'cn'"
                class="w-1.5 h-1.5 rounded-full bg-primary shrink-0"
              ></span>
            </button>
            <button
              type="button"
              class="shell-header-menu-btn w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors border-0 cursor-pointer text-left hover:bg-muted"
              [ngClass]="{
                'bg-primary/10 text-primary': translate.currentLang === 'jn',
                'text-foreground': translate.currentLang !== 'jn'
              }"
              (click)="saveLang('jn')"
            >
              <span class="flex items-center gap-2">
                <span
                  class="fi fi-jp w-5 h-[15px] shrink-0 rounded-sm"
                  aria-hidden="true"
                ></span>
                <span>日本語 (Nihongo)</span>
              </span>
              <span
                *ngIf="translate.currentLang === 'jn'"
                class="w-1.5 h-1.5 rounded-full bg-primary shrink-0"
              ></span>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="relative">
      <button
        type="button"
        class="shell-header-ghost-btn p-2 rounded-full transition-colors hidden sm:block"
        [ngClass]="{
          'bg-muted text-primary': isModuleDropdownOpen,
          'text-muted-foreground hover:bg-muted': !isModuleDropdownOpen
        }"
        aria-label="Module"
        (click)="
          isModuleDropdownOpen = !isModuleDropdownOpen;
          isLanguageDropdownOpen = false;
          isUserMenuOpen = false
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="w-[18px] h-[18px]"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      <ng-container *ngIf="isModuleDropdownOpen">
        <div
          class="fixed inset-0 z-[90]"
          (click)="isModuleDropdownOpen = false"
        ></div>
        <div
          class="absolute top-full mt-2 bg-card border border-border z-[100] p-3 w-[min(520px,calc(100vw-1.5rem))] rounded-[var(--radius-card2)] shadow-elevation-md right-0 sm:right-[-80px] md:right-[-120px]"
        >
          <div class="pb-3 border-b border-border mb-3">
            <h3 class="text-foreground text-sm font-medium">Các Module</h3>
            <p class="text-muted-foreground mt-0.5 text-xs">
              Chọn module để truy cập
            </p>
          </div>

          <div *ngIf="cats?.length" class="grid grid-cols-3 gap-1.5">
            <a
              *ngFor="let cat of cats"
              [href]="cat.webUrl"
              class="content-stretch flex flex-col gap-3 items-center justify-center p-4 relative rounded-xl cursor-pointer transition-all hover:bg-muted no-underline text-inherit"
            >
              <div
                class="w-10 h-10 flex items-center justify-center text-foreground"
              >
                <i
                  class="text-2xl"
                  [ngClass]="cat.iconClass ? cat.iconClass : 'uni uni-overview'"
                ></i>
              </div>
              <div class="text-center w-full">
                <p class="text-sm text-foreground">{{ cat.webName }}</p>
              </div>
            </a>
          </div>
          <p
            *ngIf="!cats?.length"
            class="text-sm text-muted-foreground py-4 text-center"
          >
            Chưa có module.
          </p>

          <div class="pt-3 border-t border-border mt-3">
            <button
              type="button"
              class="shell-header-menu-btn shell-header-menu-btn--primary w-full flex items-center justify-center gap-2 px-3 py-2 text-primary hover:bg-primary/10 transition-colors rounded-lg text-xs font-medium border-0 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z"
                  clip-rule="evenodd"
                />
              </svg>
              Xem tất cả module
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="relative ml-4">
      <button
        type="button"
        class="shell-header-user-btn hidden sm:flex items-center gap-2 hover:bg-muted pl-2 pr-4 py-1.5 transition-colors border-0 cursor-pointer rounded-[var(--radius-pill)]"
        (click)="
          isUserMenuOpen = !isUserMenuOpen;
          isModuleDropdownOpen = false;
          isLanguageDropdownOpen = false
        "
      >
        <div
          class="w-9 h-9 bg-center bg-no-repeat bg-cover rounded-full shrink-0 bg-muted"
          [ngStyle]="avatarStyle"
        ></div>
        <div class="text-left min-w-0 hidden lg:block">
          <p class="text-foreground truncate text-sm font-medium">
            {{ userName }}
          </p>
          <p class="text-muted-foreground truncate text-xs">
            {{ userEmail }}
          </p>
        </div>
      </button>

      <ng-container *ngIf="isUserMenuOpen">
        <div
          class="fixed inset-0 z-[90]"
          (click)="isUserMenuOpen = false"
        ></div>
        <div
          class="absolute right-0 top-full mt-2 bg-card border border-border z-[100] min-w-[200px] rounded-[var(--radius-card2)] shadow-elevation-md"
        >
          <div class="py-2 text-sm">
            <button
              type="button"
              class="shell-header-menu-btn w-full flex items-center gap-3 px-4 py-2 text-foreground hover:bg-muted transition-colors border-0 cursor-pointer text-left"
              (click)="goDeviceActivity()"
            >
              <i class="pi pi-history w-4 h-4 text-muted-foreground shrink-0 text-sm"></i>
              <span>{{ '_Lịch sử đăng nhập_' | translate }}</span>
            </button>
          </div>
          <div class="border-t border-border py-2">
            <button
              type="button"
              class="shell-header-menu-btn shell-header-menu-btn--danger w-full flex items-center gap-3 px-4 py-2 text-red-600 hover:bg-red-50 transition-colors border-0 cursor-pointer text-left font-medium"
              (click)="logout()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a.75.75 0 0 1 0-1.5h6V5.25h-6a.75.75 0 0 1 0-1.5h6Zm-5.03 4.72a.75.75 0 0 1 0 1.06L9.31 10.5l2.16 2.72a.75.75 0 1 1-1.18.94l-2.75-3.5a.75.75 0 0 1 0-.94l2.75-3.5a.75.75 0 0 1 1.06 0ZM4.5 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>{{ '_Logout_' | translate }}</span>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</header>
